import { CopyIcon } from "../../../svg/copy-icon";

interface CmmKeyDisplayProps {
  cmmKey: string;
}

const CmmKeyDisplay = ({ cmmKey }: CmmKeyDisplayProps) => {
  return (
    <div className="cmm-result-key ml-auto mr-2 flex items-center gap-2 text-small">
      Cmm Key:{" "}
      <span className="font-bold">
        {cmmKey}
        &nbsp;
      </span>
      <div
        className="cmm-result-key copy-icon hover:cursor-pointer"
        onClick={() => {
          navigator.clipboard.writeText(cmmKey);
        }}
      >
        <CopyIcon />
      </div>
    </div>
  );
};

export default CmmKeyDisplay;
